import * as UserApi from './api/user';
import * as VehicleApi from './api/vehicles';

export default {
	...UserApi,
	...VehicleApi,
};
